import React from 'react';
import styled from 'styled-components';
const Image = styled.img.withConfig({
  displayName: "AdamaraLogo__Image",
  componentId: "sc-18buhyu-0"
})(["margin:5px;margin-bottom:15px;"]);
export const AdamaraLogo = () => {
  return /*#__PURE__*/React.createElement(Image, {
    src: "assets/branding/ADAMARA_harshwaters_loading.png",
    alt: "logo"
  });
};